import React, { useMemo } from 'react';
import { completeDeliveryStatusCounts, getDeliveryStatusMeta } from './statusConfig';
import {
    StatusCountCard,
    StatusCountLabel,
    StatusCountsError,
    StatusCountsGrid,
    StatusCountsHeader,
    StatusCountsSection,
    StatusCountsTitle,
    StatusCountValue,
} from './DeliveriesList.styles';

/**
 * Seção de contagem por status da listagem de entregas.
 * Seleção múltipla: clique seleciona; clique de novo remove da seleção.
 *
 * @param {{
 *   items?: Array<{ status: string, count: number }>,
 *   selectedStatuses?: string[],
 *   onToggle: (status: string) => void,
 *   loading?: boolean,
 *   error?: string | null,
 * }} props
 */
export default function DeliveryStatusCounts({
    items = [],
    selectedStatuses = [],
    onToggle,
    loading = false,
    error = null,
}) {
    const counts = useMemo(() => completeDeliveryStatusCounts(items), [items]);
    const selectedSet = useMemo(() => new Set(selectedStatuses || []), [selectedStatuses]);

    return (
        <StatusCountsSection aria-label="Entregas por status" aria-busy={loading || undefined}>
            <StatusCountsHeader>
                <StatusCountsTitle>Entregas por status</StatusCountsTitle>
            </StatusCountsHeader>
            {error ? <StatusCountsError role="alert">{error}</StatusCountsError> : null}
            <StatusCountsGrid>
                {counts.map((item) => {
                    const meta = getDeliveryStatusMeta(item.status);
                    const selected = selectedSet.has(item.status);
                    const countLabel = loading && !items.length
                        ? '—'
                        : Number(item.count).toLocaleString('pt-BR');
                    return (
                        <StatusCountCard
                            key={item.status}
                            type="button"
                            $colorToken={meta.colorToken}
                            $selected={selected}
                            aria-pressed={selected}
                            title={selected ? `Remover filtro: ${meta.label}` : `Filtrar por: ${meta.label}`}
                            onClick={() => onToggle(item.status)}
                        >
                            <StatusCountLabel>{meta.label}</StatusCountLabel>
                            <StatusCountValue>{countLabel}</StatusCountValue>
                        </StatusCountCard>
                    );
                })}
            </StatusCountsGrid>
        </StatusCountsSection>
    );
}
